import * as yup from 'yup';

export default yup.object().shape({
  fallback: yup.object().shape({
    name: yup.string().required('Stack name is required').trim(),
  }),
});
